module.exports = __webpack_public_path__ + "assets/img/casehistory-detail-back.ded446d1.png";